import React from 'react';
import { TenantSelectorProvider } from 'contexts/TenantSelectorContext';
import TenantSelectionDialogContent from './TenantSelectionDialogContent';

interface TenantSelectionDialogProps {
    setOpen: (val: boolean) => void;
    open: boolean;
}

const TenantSelectionDialog = ({ setOpen, open }: TenantSelectionDialogProps) => (
    <TenantSelectorProvider switchTenantLogin handleClose={() => setOpen(false)} immediate>
        <TenantSelectionDialogContent open={open} />
    </TenantSelectorProvider>
);

export default TenantSelectionDialog;
